import './App.css';
import Main from './Components/Main';

let App=()=>{
  return (
    <div>
      <Main/>
    </div>
  );
}

export default App;
